import actionCreatorFactory from "typescript-fsa"; // FSA = Flus Standard Actions; has properties type, payload, error (whether payload is error object; optional) and meta (optional).

import * as types from "./actionTypes";

import { DataService } from "../data/DataService";

import { IAddOrEditEvent, IAddOrEditEventResponse } from "../classes/event";

import { setEventId, setEventScreenMode } from "./calendarSettingsActions";

import { beginAjaxCall } from "./ajaxActions";

const actionCreator = actionCreatorFactory();

export const addOrEditEventError_Success = actionCreator<IAddOrEditEventResponse>(types.ADD_OR_EDIT_EVENT_ERROR_SUCCESS);
export const clearErrorMessage = actionCreator(types.ADD_OR_EDIT_EVENT_CLEAR_ERROR_MESSAGE);
export const setStartDateAction = actionCreator<Date>(types.SET_START_DATE);
export const setDateOfFirstEventInRecurrenceAction = actionCreator<Date>(types.SET_DATE_OF_FIRST_EVENT_IN_RECURRENCE);

const dataService = new DataService();

export function addOrEditEvent(eventFieldsToAddOrEdit: IAddOrEditEvent) {
  return (dispatch) => {

    dispatch(beginAjaxCall());

    return dataService.addOrEditEvent(eventFieldsToAddOrEdit).then((response: any) => {

      if (response.d !== undefined) { response = response.d; } // .NET service wraps response in a 'd' property.

      const eventResponse: IAddOrEditEventResponse = response;

      dispatch(addOrEditEventError_Success(eventResponse));

      if (eventResponse.errorMessage.trim() === "") {
        // If no error, return to the list view of the calendar, and refresh the list of events so it will include the added/edited event.
        dispatch(setEventScreenMode("LIST"));
        dispatch(setEventId(0));
      }

    }).catch((error) => {
      const eventResponse: IAddOrEditEventResponse = { action: "", eventID: 0, errorMessage: "An error occurred when attempting to contact the service." };
      dispatch(addOrEditEventError_Success(eventResponse));
    });
  };
}

export function setStartDate(startDate: Date) {
  return (dispatch) => {
    dispatch(setStartDateAction(startDate));
  };
}

export function setDateOfFirstEventInRecurrence(dateOfFirstEventInRecurrence: Date) {
  return (dispatch) => {
    dispatch(setDateOfFirstEventInRecurrenceAction(dateOfFirstEventInRecurrence));
  };
}
